import { React, useState, useEffect } from 'react';
import s from "../SettingData/SettingData.module.css"
import { useUser } from '../../Context/UserContext';
import { SubmitButtonForm } from '../shared/SubmitButtonForm'
import { createGroup } from '../../Api/NbiotApi'
import { createOrganization } from '../../Api/OrganizationApi'
import { useFormik } from 'formik';
import { FormControl, FormControlLabel, FormGroup, FormHelperText, InputLabel, MenuItem, Typography, Checkbox } from '@mui/material';
import { useHideMessage } from '../SettingData/Forms';
import { ModalTemplate } from "../shared/ModalForms";
import { FormTextField } from '../shared/FormTextField';
import { FormSelect } from '../shared/FormSelect';
import { brandIoT } from '../../constants/constants';


export const OrganizationForm = ({ onSuccess }) => {
    const { fetchUserData } = useUser();
    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            name: "",
            dev_type: "",
            connection_types: [],
        },
        validate: (values) => {
            const errors = {};
            if (!values.connection_types?.length) {
                errors.connection_types = 'Выберите хотя бы один тип подключения.';
            }
            return errors;
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createOrganization(values);

                if (onSuccess) {
                    onSuccess(data.org);
                }

                await fetchUserData()
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Создание организации
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormTextField formik={formik} name={"name"} value={formik.values.name} label={"Название"} />
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Тип устройств</InputLabel>
                <FormSelect formik={formik} name={"dev_type"} label="Тип устройств" value={formik.values.dev_type}>
                    <MenuItem value={"ВС"}>Счетчики воды</MenuItem>
                    <MenuItem value={"ЭС"}>Счетчики электроэнергия</MenuItem>
                    <MenuItem value={"ТС"}>Счетчики теплоэнергия</MenuItem>
                    <MenuItem value={"ГС"}>Счетчики газа</MenuItem>
                </FormSelect>
            </FormControl>
            <FormControl
                component="fieldset"
                variant="standard"
                fullWidth
                sx={{ marginTop: 2 }}
                error={Boolean(formik.errors.connection_types)}
            >
                <Typography component="legend" sx={{ marginBottom: 0.5 }}>
                    Тип связи с устройствами
                </Typography>
                <FormGroup row>
                    {brandIoT.map((option) => (
                        <FormControlLabel
                            key={option}
                            control={
                                <>
                                    <Checkbox
                                        checked={formik.values.connection_types.includes(option)}
                                        onChange={(e) => {
                                            const next = e.target.checked
                                                ? [...formik.values.connection_types, option]
                                                : formik.values.connection_types.filter((v) => v !== option);
                                            formik.setFieldValue('connection_types', next);
                                        }}
                                        name="connection_types"
                                        value={option}
                                    />
                                </>
                            }
                            label={option}
                        />
                    ))}
                </FormGroup>
                {formik.errors.connection_types && (
                    <FormHelperText>{formik.errors.connection_types}</FormHelperText>
                )}
            </FormControl>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}


export const GroupForm = ({ onSuccess }) => {
    const { user, fetchUserData } = useUser();

    const [openOrg, setOpenOrg] = useState(false);
    const handleOpenOrg = () => setOpenOrg(true);
    const handleCloseOrg = () => setOpenOrg(false);

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            name: "",
            organization: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createGroup(values);

                if (onSuccess) {
                    onSuccess(data.group);
                }
                await fetchUserData()
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const handleOrgSuccess = (newOrg) => {
        formik.setFieldValue('organization', newOrg.id);
        handleCloseOrg();
    };

    useEffect(() => {
        if (user.organization) {
            formik.setFieldValue('organization', formik.values.organization || '');
        }
    }, [user]);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Создание группы
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormTextField formik={formik} name={"name"} value={formik.values.name} label={"Название"} />
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Название организации</InputLabel>
                <FormSelect formik={formik} name={"organization"} label="Название организации" value={formik.values.organization}>
                    <MenuItem value="" onClick={handleOpenOrg}>
                        + Создать новую организацию
                    </MenuItem>
                    {[...user.organization].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(org => (
                        <MenuItem value={org.id} key={org.id}>{org.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate open={openOrg} onClose={handleCloseOrg}>
                    <OrganizationForm onSuccess={handleOrgSuccess} />
                </ModalTemplate>
            </FormControl>
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}
